export function gql(strings: TemplateStringsArray, ...vals: any) {
  const ret = [];
  for (const i in strings.raw) {
    if (strings.raw[i]) {
      ret.push(strings.raw[i], vals[i] || '');
    }
  }
  return ret.join('');
}
